export default __webpack_public_path__ + "static/media/emptyAttribute.7336a804.svg";